<template>
  <div class="novedades-body v-application">

    <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        
      >
        <v-card-text>
         <div class="loadTitle">
        <img :src="images.logo" /> <label>Cargando...</label>
        </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <section class="novedades" v-show="novedades.contenidos.length>0">
      <div class="novedades-container">
        <div class="novedades-title">
          <h2><span class="bricsa-square"></span>Novedades</h2>
        </div>
        <div class="novedades-group container">
          <router-link :to="{ name: 'novedad', params: { name: nove.post_name }}"
          class="novedades-item"
            v-for="(nove, index) in novedades.contenidos"
            :key="index" 
          >
            <div class="novedades-item__img"><img :src="nove.img" /></div>
            <div class="novedades-item__text">
              <div class="novedades-item__title">
                <h3>{{ nove.post_title }}</h3>
              </div>
              <div class="novedades-item__info">
                <p>{{ nove.resumen }}</p>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </section>
    <section class="sociales" v-show="sociales.contenidos.length>0">
      <div class="sociales-container">
        <div class="sociales-title">
          <h2><span class="bricsa-square"></span>Páginas sociales</h2>
        </div>
        <div class="sociales-group container">
          <router-link :to="{ name: 'novedad', params: { name: soci.post_name }}"
            class="sociales-item"
            v-for="(soci, index) in sociales.contenidos"
            :key="index"
          >
            <div class="sociales-item__img"><img :src="soci.img" /></div>
            <div class="sociales-item__text">
              <div class="sociales-item__title">
                <h3>{{ soci.post_title }}</h3>
              </div>
              <div class="sociales-item__info">
                <p>{{ soci.resumen }}</p>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </section>
    <section class="condominio" v-show="condominios.contenidos.length>0">
      <div class="condominio-container">
        <div class="condominio-title">
          <h2><span class="bricsa-square"></span>Mi Condominio</h2>
        </div>
        <div class="condominio-group container">
           <router-link :to="{ name: 'novedad', params: { name: cond.post_name }}"
            class="condominio-item"
            v-for="(cond, index) in condominios.contenidos"
            :key="index"
          >
            <div class="condominio-item__img"><img :src="cond.img" /></div>
            <div class="condominio-item__text">
              <div class="condominio-item__title">
                <h3>{{ cond.post_title }}</h3>
              </div>
              <div class="condominio-item__info">
                <p>{{ cond.resumen }}</p>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from 'moment'
import { GET_NOVEDADES, GET_SOCIALES, GET_CONDOMINIOS } from "@/core/services/store/contenido.module";
moment.locale( 'es' );
export default {
  data() {
    return {
      images: {
                family: process.env.BASE_URL + 'media/family.jpg',
                logo: process.env.BASE_URL +'media/logo.png',
            },
      loading:true,
      isFullPage: true
    };
  },
mounted () {
    this.getNovedades();
    this.getCondominios();
    this.getSociales();
  },
  filters:{
    formatDate(value) {
        const duration = moment(value).format('DD/MM/yyyy');
        return `${duration}`;
    },

    formatTime(value) {
        const hora = moment(value).format('HH:mm:ss');
        return `${hora}`;
    }
  },
  methods: {
    getNovedades() {
      this.$Progress.start();
      this.$store
          .dispatch(GET_NOVEDADES, null)
          .then(()=>{
            this.$Progress.finish()
            this.loading=false;
      });
    },
    getSociales() {
      this.$Progress.start();
      this.$store
          .dispatch(GET_SOCIALES, null)
          .then(()=>{
            this.$Progress.finish()
      });
    },
    getCondominios() {
      this.$Progress.start();
      this.$store
          .dispatch(GET_CONDOMINIOS, null)
          .then(()=>{
            this.$Progress.finish()
      });
    }
  },
  computed: {
    ...mapState({
      errors: state => state.agreement.errors,
      novedades :state => state.contenido.novedades,
      sociales :state => state.contenido.sociales,
      condominios :state => state.contenido.condominios
    }),
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 3% 5% !important;
}
.novedades-body {
  padding: 3% 8%;
  display: grid;
  grid-template-columns: 100%;
  justify-content: space-between;
  @media screen and (max-width: 1025px) {
    row-gap: 20px;
    padding: 120px 5% 3%;
  }
  .novedades,
  .sociales,
  .condominio {
    .novedades-container,
    .sociales-container,
    .condominio-container {
      .novedades-title,
      .sociales-title,
      .condominio-title {
        h2 {
          color: #707070;
          font-size: 20px;
          font-weight: bold;
          text-align: left;
          margin: 10px;
          margin-left: 0;
          display: flex;
          align-items: baseline;
          span {
            display: block;
            width: 15px;
            height: 15px;
            margin-right: 5px;
            background: var(--bricsa-red);
          }
        }
      }
      .novedades-group,
      .sociales-group,
      .condominio-group {
        display: grid;
        grid-template-columns: repeat(2, 49%);
        justify-content: space-between;
        row-gap: 20px;
        @media screen and (max-width: 1025px) {
          grid-template-columns: 100%;
        }
        .novedades-item,
        .sociales-item,
        .condominio-item {
          display: grid;
          grid-template-columns: 40% 60%;
          height: 150px;
          -webkit-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
          -moz-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
          box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
          color: var(--bricsa-grey);
          .novedades-item__img,
          .sociales-item__img,
          .condominio-item__img {
            height: 150px;
            img {
              height: inherit;
              width: 100%;
              object-fit: cover;
            }
          }
          .novedades-item__text,
          .sociales-item__text,
          .condominio-item__text {
            display: grid;
            grid-template-rows: repeat(2, max-content);
            row-gap: 10px;
            padding: 10px 0;
            .novedades-item__title,
            .sociales-item__title,
            .condominio-item__title {
              h3 {
                color: var(--bricsa-grey);
                text-align: left;
                font-weight: bold;
                width: 95%;
                height: fit-content;
                padding: 0 10px;
                overflow: hidden;
                height: fit-content;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }
            }
            .novedades-item__info,
            .sociales-item__info,
            .condominio-item__info {
              width: 95%;
              height: fit-content;
              padding: 0 10px;
              p {
                text-align: left;
                font-size: 12px;
                overflow: hidden;
                height: calc(1.1rem * 5);
                display: -webkit-box;
                -webkit-line-clamp: 5;
                -webkit-box-orient: vertical;
              }
            }
          }
        }
      }
    }
  }
}
</style>